<div class="flex justify-between px-4 pt-4 md:px-8 md:pt-8">
  <p class="font-semibold text-2xl md:text-4xl">Bonjour {{ userFirstname }},</p>
  <div (click)="logout()" class="border rounded-lg border-light text-percian-green p-2 text-center w-f-content cursor-pointer">
    Déconnexion
  </div>
</div>